<!--
 * @Author:
 * @Description: 文档合规性校验报表
-->
<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <el-row class="mb-10px flex">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        class="w-200px mx-10px"
        size="small"
        v-model="searchData.code"
        placeholder="文档编码"
        clearable
      ></el-input>
      <el-input
        class="w-200px mr-10px"
        size="small"
        v-model="searchData.name"
        placeholder="文档名称"
        clearable
      ></el-input>
      <el-select
        v-model="searchData.classId"
        placeholder="文档类别"
        class="w-200px mr-10px"
        size="small"
        collapse-tags
        filterable
        clearable
      >
        <el-option
          v-for="item in classTypeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="!$hasAccess('rulesSetting')"
        @click="toRulesSetting"
        >规则设置</el-button
      >
      <el-button
        size="small"
        type="primary"
        :disabled="!$hasAccess('export')"
        :loading="exportLoading"
        @click="exportData"
        >导出</el-button
      >
    </el-row>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      class="mt-20px"
      height="calc(100% - 104px)"
      border
      stripe
    >
      <el-table-column type="index" width="65" :label="`${$t('serialNumber')}`">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(val, index) in tableHeaders"
        :key="index"
        :label="val.name"
        :prop="val.columnName"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px text-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="$pageSizeAll"
      @current-change="getTableData"
      @size-change="searchList"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import dataValidationReportService from '@/services/dataValidationReportService'
import stdClassListService from '@/services/stdClassListService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'documentComplianceReport',
  components: {
    selectStandardId,
  },
  mixins: [fnMixin],
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      searchData: {
        code: '',
        name: '',
        classId: '',
      },
      docList: [],
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      tableLoading: false,
      exportLoading: false,
      tableHeaders: [],
      classTypeList: [],
    }
  },
  created() {
    this.getTypeList()
    this.searchList()
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.getTypeList()
      this.searchList()
    },
    // 搜索列表
    searchList() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      const params = {
        standardId: this.standardId,
        type: 1, // 0: 对象, 1: 文档
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        ...this.searchData,
      }
      this.tableLoading = true
      const res = await dataValidationReportService.getDataValidationComplianceList(params)
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableHeaders = res.headers.filter((item) => {
          return item.isDisplay
        })
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    // 获取类别下拉数据
    async getTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
        info_type: 1, // 文档
        catecode: 'Document', // 文档
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0) {
        this.classTypeList = res.data
      }
    },
    // 跳转规则设置
    toRulesSetting() {
      this.$router.push({
        path: 'rule-settings',
        query: {
          type: 'document',
        },
      })
    },
    // 导出
    async exportData() {
      const params = {
        standardId: this.standardId,
        type: 1, // 0: 对象, 1: 文档
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        ...this.searchData,
      }
      this.exportLoading = true
      const res = await dataValidationReportService.getDataValidationComplianceExport(params)
      this.exportLoading = false
      if (res) {
        this.downLoadBlob({
          name: '文档合规性校验报表导出结果.xlsx',
          data: res,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
